/**
 * OPS-1: whether the new-booking form holds anything the counter typed. The
 * form has no notion of its own: thirty-odd pieces of state, some filled by
 * the app itself (a Planning drag's prefill, the first terminal as the pick-up
 * place, a customer's record). So the screen takes a snapshot of what the
 * person can change, once at first render, and compares the current one to it:
 * a prefill is in the first snapshot and counts as untouched; an app-made
 * default is left out of both by the caller.
 */
export type FormSnapshot = Readonly<Record<string, unknown>>

/** The same value, whatever the key order, is the same snapshot. */
function canonical(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonical).join(',')}]`
  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, v]) => v !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonical(v)}`).join(',')}}`
  }
  return JSON.stringify(value) ?? 'undefined'
}

export function isDirty(initial: FormSnapshot, current: FormSnapshot): boolean {
  return canonical(initial) !== canonical(current)
}
